<!--
  Error Page

  @since 2018-02-09
  @author kdydesign.kim
-->

<template>
  <div class="content-group">
    <div class="contents-row">
      <div class="portlet">
        <div class="contents-row t-center">
          <p class="ico-error"></p>
          <p class="txt-error">{{ $t('msg.error_sessionExpired_mustBeLogin') }}</p>
          <!--<p class="txt-error">다음 상황으로 에러가 발생했습니다.</p>-->
          <!--<br/>-->
          <!--<p class="txt-error">에러 코드: Client Error ({{statusCode}})</p>-->
          <!--<p class="txt-error">에러 라우팅: {{$route.path}}</p>-->
          <!--<p class="txt-error">에러 내용: {{errorMessage}}</p>-->
          <!--<p class="txt-error">세부 에러 내용: {{detailErrorMessage}}</p>-->
          <br/>

          <p class="txt-error">{{ $t('msg.error_relogin') }}</p>
          <q-btn label="LOGIN >"
                 v-if="loginShow"
                 color="primary"
                 class="bs bs-q-btn-md marB20 marT20"
                 :ha-force="true"
                 @click="onLogout"></q-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  // store helper
  const authenticateStore = createNamespacedHelpers('common/authenticate')

  export default {
    name: 'ErrorPage',
    props: ['error'],
    computed: {
      errorMessage () {
        const statusCode = Number(this.error.statusCode)

        if (statusCode === 204) {
          return 'No Content'
        }

        if (statusCode === 400) {
          return 'Bad Request'
        }

        if (statusCode === 401) {
          return 'Unauthorized'
        }

        if (statusCode === 402) {
          return 'Forbidden'
        }

        if (statusCode === 404) {
          return 'Page Not Found'
        }

        if (statusCode === 405) {
          return 'Method Not Allowed'
        }

        if (statusCode === 500) {
          return 'Internal Server Error'
        }

        return 'Error'
      },
      detailErrorMessage () {
        return this.error.message
      },
      statusCode () {
        return this.error.statusCode
      },
      loginShow () {
        if (this.$route.query.newWindow) {
          return false
        }
        return true
      }
    },
    created () {
      let self = this

      window.onpopstate = (event) => {
        self.logout()
      }
    },
    mounted () {
      this.$parent.$parent.$el.classList.add('page-new-window', 'page-toolbar-default')
      this.$parent.$parent.$children[0].$el.style.display = 'none'
    },
    methods: {
      ...authenticateStore.mapActions([
        'logout'
      ]),
      onLogout () {
        this.logout()
      }
    }
  }
</script>
